// extracted by mini-css-extract-plugin
module.exports = {"Process":"Process_Process__1rbLH","Process__Circle__Container":"Process_Process__Circle__Container__baMRf"};